export default __webpack_public_path__ + "static/media/four-brex.5f65fefb.png";